// Auth glue — Path A (gateway-cookie SSO).
//
// There is no login form in this SPA. The auth gateway at create.overdigital.ai
// owns the login UI (TOTP, lockout, history). On first visit the SPA calls
// /api/me; if it gets 401, api.js redirects to the gateway login with a return
// URL, and the user lands back here authenticated.
//
// Once the gateway cookie (Domain=.overdigital.ai) is set, every subsequent
// /api/* call carries it via credentials:'include'.

import { api, loginRedirect } from './api.js';

let _me = null;

export async function ensureLoggedIn() {
  if (_me) return _me;
  try {
    _me = await api.get('/api/me');
    return _me;
  } catch (err) {
    // api.js already initiated the redirect on 401; rethrow for callers
    throw err;
  }
}

export function logout() {
  // Gateway owns logout; this clears any in-memory cache and bounces.
  _me = null;
  window.location.href = 'https://create.overdigital.ai/__auth/logout';
}

export function getCurrentUser() {
  return _me;
}

export { loginRedirect };
